
export const reviews = [
  {
    name: 'Chidinma Okafor',
    location: 'Maitama, Abuja',
    rating: 5,
    date: 'December 2024',
    comment: 'Absolutely phenomenal work! The team at Exquisite Spaces transformed our home into something truly breathtaking. Their creativity and professionalism are unmatched in Abuja.',
    avatar: 'https://public.readdy.ai/ai/img_res/9df49ff7058634c05fc483a15cfd6cc0.jpg'
  },
  {
    name: 'Emeka Nwosu',
    location: 'Wuse II, Abuja',
    rating: 5,
    date: 'November 2024',
    comment: 'From start to finish, the experience was seamless. They understood our vision perfectly and delivered beyond our expectations. I recommend Exquisite Spaces to every Nigerian homeowner.',
    avatar: 'https://readdy.ai/api/search-image?query=realistic%20portrait%20photo%20of%20a%20handsome%20Nigerian%20man%20in%20his%2040s%20dark%20skin%20well-groomed%20wearing%20a%20crisp%20white%20dress%20shirt%20confident%20professional%20look%20clean%20neutral%20background%20studio%20lighting&width=200&height=200&seq=ng-rev-202&orientation=squarish'
  },
  {
    name: 'Adaeze Eze',
    location: 'Garki, Abuja',
    rating: 5,
    date: 'November 2024',
    comment: 'The attention to detail is incredible. Every corner of our home feels thoughtfully designed. We couldn\'t be happier with the results — truly world-class interior design!',
    avatar: 'https://readdy.ai/api/search-image?query=realistic%20portrait%20photo%20of%20a%20young%20Nigerian%20woman%20in%20her%20late%2020s%20rich%20dark%20skin%20braided%20hair%20wearing%20a%20stylish%20top%20bright%20eyes%20warm%20smile%20soft%20natural%20lighting%20neutral%20background&width=200&height=200&seq=ng-rev-203&orientation=squarish'
  },
  {
    name: 'Babatunde Adeyemi',
    location: 'Asokoro, Abuja',
    rating: 5,
    date: 'October 2024',
    comment: 'Exquisite Spaces transformed our office into a space that inspires creativity and productivity. The team was professional, responsive, and incredibly talented. Highly impressed!',
    avatar: 'https://readdy.ai/api/search-image?query=realistic%20portrait%20photo%20of%20a%20mature%20Nigerian%20man%20in%20his%2050s%20dark%20complexion%20short%20grey%20hair%20wearing%20a%20well-fitted%20suit%20professional%20headshot%20warm%20lighting%20clean%20background&width=200&height=200&seq=ng-rev-204&orientation=squarish'
  },
  {
    name: 'Ngozi Obi',
    location: 'Jabi, Abuja',
    rating: 5,
    date: 'October 2024',
    comment: 'Working with this team was a dream. They made the entire process stress-free and the final result is absolutely stunning. Worth every kobo! I will definitely use them again.',
    avatar: 'https://readdy.ai/api/search-image?query=realistic%20portrait%20photo%20of%20a%20Nigerian%20woman%20in%20her%2030s%20dark%20glowing%20skin%20wearing%20a%20colourful%20headwrap%20and%20elegant%20blouse%20bright%20cheerful%20smile%20warm%20studio%20lighting%20neutral%20background&width=200&height=200&seq=ng-rev-205&orientation=squarish'
  },
  {
    name: 'Chukwuemeka Igwe',
    location: 'Gwarinpa, Abuja',
    rating: 5,
    date: 'September 2024',
    comment: 'The design exceeded all our expectations. The space is not only beautiful but also incredibly functional. A highly professional team — the best interior designers in Abuja!',
    avatar: 'https://readdy.ai/api/search-image?query=realistic%20portrait%20photo%20of%20a%20young%20Nigerian%20man%20in%20his%20early%2030s%20dark%20skin%20wearing%20glasses%20and%20smart%20casual%20shirt%20friendly%20confident%20smile%20clean%20neutral%20background%20studio%20light&width=200&height=200&seq=ng-rev-206&orientation=squarish'
  }
];
